export default __webpack_public_path__ + "static/media/whats.2b4a0cdc.svg";